import { OperationType } from "../miscellaneous/operation-type.enum";

export class QueryFilterParameter {
	constructor(
		public fieldName: string,
		public value: string,
		public operation: OperationType,
	) { }
}

export class QueryParameter {
	public fieldName: string;
	public value: string;
	public operation: OperationType;
}
